module.exports = __webpack_public_path__ + "img/GAME_QUIZ.91edfdc5.jpg";